import { white } from '@kmns-internal/furikake'
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type { Schedule } from '@ulysses-inc/harami_api_client'
import type { Dispatch, FC, SetStateAction } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from 'src/state/store'
import ScheduleListRow from './ScheduleListRow'

export type TChooseScheduleUUIDsState = {
  chooseScheduleUUIDsState: [string[], Dispatch<SetStateAction<string[]>>]
}

const ScheduleListContent: FC<TChooseScheduleUUIDsState> = ({
  chooseScheduleUUIDsState,
}) => {
  const [chooseScheduleUUIDs, setChooseScheduleUUIDs] = chooseScheduleUUIDsState

  const schedules = useSelector(
    (state: RootState) => state.schedulesState.schedules.schedules,
  )

  const isCheckedAll = () => {
    if (schedules.length === 0) return false
    const unChecked = schedules.filter(
      ({ uuid }) => !(uuid && chooseScheduleUUIDs.some(v => v === uuid)),
    )
    return unChecked.length === 0
  }

  const handleCheckAll = (checked: boolean) => {
    if (checked) {
      const uuids = schedules
        .map(({ uuid }) => uuid ?? '')
        .filter(uuid => uuid !== '')
      setChooseScheduleUUIDs(uuids)
    } else {
      setChooseScheduleUUIDs([])
    }
  }

  return (
    <TableContainer>
      <Table sx={{ backgroundColor: white }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: white }}>
            <TableCell size="small">
              <Checkbox
                checked={isCheckedAll()}
                onChange={e => handleCheckAll(e.target.checked)}
              />
            </TableCell>
            <TableCell size="small" sx={{ wordBreak: 'break-all' }}>
              スケジュール名
            </TableCell>
            <TableCell
              size="small"
              sx={{ wordBreak: 'break-all', width: '20%' }}
            >
              ひな形名
            </TableCell>
            <TableCell size="small" sx={{ width: '15%' }}>
              ステータス
            </TableCell>
            <TableCell size="small" sx={{ width: '12%' }}>
              開始日
            </TableCell>
            <TableCell size="small" sx={{ width: '12%' }}>
              終了日
            </TableCell>
            <TableCell size="small" sx={{ width: '60px' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schedules.map((schedule: Schedule) => (
            <ScheduleListRow
              key={schedule.id}
              {...{ schedule, chooseScheduleUUIDsState }}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ScheduleListContent
